import React, { createContext, useContext, useEffect, useState } from 'react';
import { adminLogin, adminLogout, adminMe } from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);   // null = checking, false = logged out
  const [ready, setReady] = useState(false);

  useEffect(() => {
    adminMe()
      .then((res) => setUser(res.data))
      .catch(() => setUser(false))
      .finally(() => setReady(true));
  }, []);

  const login = async (username, password) => {
    const { data } = await adminLogin(username, password);
    if (data?.token) localStorage.setItem('chimera_admin_token', data.token);
    setUser({ username: data.username });
    return data;
  };

  const logout = async () => {
    try { await adminLogout(); } catch {}
    localStorage.removeItem('chimera_admin_token');
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
